import React, { useState, useEffect } from "react";

import { LoopIcon, IconClose } from "../Icons";
import _ from "../../../i18n";


const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

const SearchBox = ({ filter, placeholder, nbResult, fetching, onChange }) => {
  const [inputValue, setInputValue] = useState(filter.keyWord || "");
  const [visibleCount, setVisibleCount] = useState(false);

  const debouncedSearch = useDebounce(inputValue, 300);

  // useEffect(() => {
  //   if (debouncedSearch.length >= 3 || debouncedSearch.length === 0) {
  //     onChange(debouncedSearch);
  //   }
  // }, [debouncedSearch, onChange]);

  useEffect(() => {
    console.log("filter.keyWord >> ", debouncedSearch);
    if (debouncedSearch.length >= 3 || debouncedSearch.length === 0) {
      try {
        if (typeof onChange === 'function') {
          onChange(debouncedSearch);
        } else {
          console.warn("warning >> ", onChange);
        }
      } catch (error) {
        console.error("error >> ", error);
      }
    }
  }, [debouncedSearch]);

  const clearAll = () => {
    setVisibleCount(false);
    setInputValue("");
    onChange(""); // Envoie d'un filtre vide
  };

  const getSearchValueStyle = () => ({
    width: 44,
    height: 19,
    padding: 5,
    fontSize: 13,
    marginRight: 5,
    borderRadius: 13,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "rgb(255, 255, 255)",
    background: "rgb(109, 127, 146)",
  });

  return (
    <div className="search-box">
      <span className="search-box__icon">
        <LoopIcon />
      </span>
      <input
        value={inputValue}
        placeholder={`${_(placeholder || "search")} ...`}
        onChange={(event) => {
          setInputValue(event.target.value);
          setVisibleCount(true);
        }}
      />
      {nbResult && visibleCount && !fetching ? (
        <div style={getSearchValueStyle()}>{nbResult}</div>
      ) : null}
      {inputValue && (
        <div onClick={() => clearAll()}>
          <IconClose size={9} />
        </div>
      )}
    </div>
  );
};

export default SearchBox;
